import toast, {ToastType} from '../Toast';
import {formatDateForTimestamp} from '@/utils/dateUtils';

const RTE_NETWORK_ERROR_KEY = 'RTE_NETWORK_ERROR_KEY';

/**
 * 将错误信息保存到本地存储中
 *
 * @param error 错误对象
 */
function saveErrorToLocal(error: Error) {
    const logs = JSON.parse(localStorage.getItem(RTE_NETWORK_ERROR_KEY) || '[]');
    logs.push({message: error.message, time: formatDateForTimestamp(Date.now())});
    localStorage.setItem(RTE_NETWORK_ERROR_KEY, JSON.stringify(logs));
}

/**
 * 进行错误上报，并清除本地存储中记录的错误信息
 */
function flushLocalErrors() {
    const logs = JSON.parse(localStorage.getItem(RTE_NETWORK_ERROR_KEY) || '[]');

    if (!logs.length) {
        return;
    }

    logs.forEach((log: { message?: string, time?: string }) => {
        const err = new Error(`${log.message}-缓存上报-${log.time}`);
        console.error(err);
    });

    localStorage.removeItem(RTE_NETWORK_ERROR_KEY);
}

/**
 * 根据网络状态决定是否立即上报错误或存入缓存
 *
 * @param error 要上报的错误对象
 */
function reportErrorWithCache(error: Error) {
    if (navigator.onLine) {
        // 网络在线，立即上报
        console.error(error);
    } else {
        // 离线，存入localStorage
        saveErrorToLocal(error);
    }
}

// 网络恢复自动上报
window.addEventListener('online', flushLocalErrors);
// 页面加载时兜底上报一次
window.addEventListener('load', flushLocalErrors);

const handleClick = () => {
    window.location.reload();
};

export const tokenErrorToast = () => {
    // 加个wierwood上报
    reportErrorWithCache(new Error('toast提示：当前网络状况不佳，请刷新页面重试'));

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    toast({
        type: ToastType.Warning,
        content: (
            <span>
                当前网络状况不佳，请刷新页面重试。<a onClick={handleClick}>刷新</a>
            </span>
        ),
        duration: -1,
        manualClose: true,
    });
};
